import styles from "./Billing.module.scss";
import PlanCard from "./PlanCard/PlanCard";
import PaymentDetailsCard from "./PaymentDetailsCard/PaymentDetailsCard";
import CreditUsageTable from "./CreditUsageTable/CreditUsageTable";
import CreditsCard from "./CreditsCard/CreditsCard";
import Banner from "../../../ui/Banner/Banner";
import { billingTierLabel } from "../../../util/billing";
import { format } from "date-fns";
import useUser from "../../../providers/UserProvider/useUser";
import Button from "../../../ui/Button/Button";
import urls from "../../../routes";
import { graphql } from "../../../__generated__/gql";
import { useMutation } from "urql";

const ReactivatePlanMutation = graphql(`
  mutation reactivePlan {
    reactivatePlan {
      downgradeBillingTier
    }
  }
`);

function Billing() {
  const { billingInfo, tenant, userOrganizations, selectOrganization } =
    useUser();
  const [reactivePlanResponse, reactivePlan] = useMutation(
    ReactivatePlanMutation,
  );

  return (
    <div>
      {!tenant?.parentTenant && billingInfo?.downgradeBillingTier && (
        <Banner className={styles.banner}>
          <span>{`Your plan will downgrade to ${
            billingTierLabel[billingInfo.downgradeBillingTier]
          } on ${format(
            new Date(billingInfo.currentPeriodEnd),
            "MMM d, yyyy",
          )}`}</span>
          <Button
            variant="outline"
            size="xsmall"
            onClick={() => reactivePlan({})}
            loading={reactivePlanResponse.fetching}
            disabled={reactivePlanResponse.fetching}
            className={styles.bannerButton}
          >
            Reactivate Plan
          </Button>
        </Banner>
      )}
      {tenant?.parentTenant && (
        <Banner className={styles.parentTenantBanner}>
          {`Your billing is managed by ${tenant.parentTenant.name}. ${
            userOrganizations?.some(
              (organization) =>
                organization.id === tenant.parentTenant?.identityId,
            )
              ? `Please switch to ${tenant.parentTenant.name} to make billing changes.`
              : `Please contact someone from ${tenant.parentTenant.name} to make billing changes.`
          }`}
          {userOrganizations?.some(
            (organization) =>
              organization.id === tenant.parentTenant?.identityId,
          ) && (
            <Button
              variant="primary"
              size="small"
              onClick={async () => {
                if (!tenant.parentTenant?.identityId) {
                  return;
                }
                await selectOrganization(tenant.parentTenant.identityId);

                window.location.href = urls.settings.billing;
              }}
            >
              Switch to {tenant.parentTenant.name}
            </Button>
          )}
        </Banner>
      )}
      <div className={styles.cards}>
        <PlanCard />
        <CreditsCard />
        <PaymentDetailsCard />
      </div>
      <CreditUsageTable />
    </div>
  );
}

export default Billing;
